import { styled } from '@material-ui/core';

export const CardWrapper = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gridTemplateRows: 'repeat(auto-fill, minmax(450px, 1fr))',
  gap: theme.spacing(3)
}));
